// extracted by mini-css-extract-plugin
module.exports = {"rateOption":"wc","rateIcon":"wd","rateLabel":"we","inPlayer":"wf","rateIconWrapper":"wh","inPlayerRateModal":"wi"};